import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { SetScreenSaverComponent } from './set-screen-saver.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    FormsModule,
    Daterangepicker
  ],
  declarations: [SetScreenSaverComponent],
  exports: [
    SetScreenSaverComponent
  ],
  providers: [
    
  ]
})
export class SetScreenSaverModule { }
